const DEFAULT_STEP = 32;
const positionRange = (offset) => {
  const arr = Array.from(Array(offset + 10), (d, i) => i);
  const chunkSize = 4;
  let newArr = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    newArr.push(arr.slice(i, i + chunkSize));
  }
  return newArr.map((x) => ({ min: x[0], max: x[x.length - 1] }));
};

const getPosition = (pos, span, offset) => {
  const range = positionRange(offset);
  const bar = range.find((x) => x.min >= pos && x.max >= pos + span);
  return bar && bar.min < pos + span ? bar.min : pos;
};

export const injectPromo = (data, products, itemOffset) => {
  if (!products) return;
  // eslint-disable-next-line array-callback-return
  return data.map((item) => {
    const promoPosition = getPosition(
      item.gridPosition - 1,
      item.cellSpan,
      itemOffset,
    );
    // position = position element in products arr, start from 0
    const position =
      itemOffset >= DEFAULT_STEP ? promoPosition - itemOffset : promoPosition;
    const filteredArr = products.filter((x) => x.type !== 'promo');

    const alreadyExistsIndex = products.findIndex(
      (x) => x?.type === 'promo' && x?.data?.gridPosition === item.gridPosition,
    );

    if (alreadyExistsIndex !== -1 && alreadyExistsIndex < itemOffset) {
      products.splice(alreadyExistsIndex, 1);
    }

    if (
      filteredArr?.[promoPosition - itemOffset] &&
      products?.[promoPosition]?.type !== 'promo' &&
      !products.find((x) => x?.data?.gridPosition === item.gridPosition)
    ) {
      return products?.splice(position, 0, {
        type: 'promo',
        data: item,
      });
    }
  });
};
